import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function Navbar() {
  const scrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById('precio');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="fixed top-0 w-full z-50" data-id="element-208">
      <div className="bg-gradient-to-r from-red-600 to-orange text-center py-1.5 px-4" data-id="element-209">
        <p className="text-[12px] font-bold text-white m-0 flex items-center justify-center gap-2 flex-wrap" data-id="element-210">
          <span data-id="element-211">⏰ OFERTA TERMINA EN:</span>
          <CountdownTimer compact={true} data-id="element-212" />
          <span data-id="element-213">— ¡No te quedes sin tu copia!</span>
        </p>
      </div>
      <nav className="bg-[rgba(10,10,10,0.95)] backdrop-blur-xl border-b border-border px-6 py-4 flex justify-between items-center" data-id="element-214">
        <a href="#" className="text-lg font-extrabold text-white no-underline" data-id="element-215">
          Fábrica <span className="text-orange" data-id="element-216">IA</span>
        </a>
        <a href="#precio" onClick={scrollToPricing} className="bg-orange text-white px-5 py-2.5 rounded-lg font-bold text-sm no-underline transition-all duration-300 hover:bg-[#FF8C00] hover:-translate-y-[1px] whitespace-nowrap" data-id="element-217">
          🚀 Obtener Acceso
        </a>
      </nav>
    </div>;
}